import React from 'react';
import './DataAnalytics.css';
import dataAnlyticsPicture from '../../images/data-analytics.jpg';
import reporting from "../../images/reporting.png";
import analytics from "../../images/analytics.png";
import crm from "../../images/crm.png";
import graph from "../../images/graphs.png";
import bulk from "../../images/bulk.png";
import segmentation from "../../images/segmentation.png";
import Header from "../../Header/Header"
import HeroSection from '../../Components/HeroSection/HeroSection';
import { Container, Row, Col } from 'bootstrap-4-react';
import { BrowserRouter as Router, Link } from "react-router-dom";
import Slide from 'react-reveal/Slide';
import Fade from 'react-reveal/Fade';
import Footer from '../../Footer/Footer';
import ReactGA from 'react-ga';

class DataAnalytics extends React.Component{
    componentDidMount() {
        ReactGA.pageview('/data-analytics');
    }
    render() {
        window.scrollTo(0, 0);
       return (
        <div className="solution-page analytics-page">
            <Header />
            <HeroSection pageTitle="Solutions" background={dataAnlyticsPicture} />
            <section className="page-content">
                <Container>
                    <ul className="breadcrumbs">
                        <li><Link to="/">Homepage</Link></li>
                        <li><Link to="/data-analytics" className="current">Data Analytics</Link></li>
                    </ul>
                </Container>
                <div className="solution-page-list">
                    <Container className="no-margin">
                        <div className="node-title">
                            <div></div>
                            <i className="fa fa-circle"></i>
                            <span> Data Analytics </span>
                            <i className="fa fa-circle"></i>
                            <div></div>
                        </div>
                        <div className="page-description-container">
                            <i className="fa fa-circle"></i>
                            <div className="page-description">
                                <p>
                                    Our real-time data analytics software provides real-time data, charts and graphs to track operational performance.
                                </p>
                            </div>
                            <i className="fa fa-circle"></i>
                        </div>
                    </Container>
                </div>
                <Container className="analytics-list">
                    <Row className="reporting">
                        <i className="fa fa-circle"></i>
                        <Col col="lg-3 md-4 12" offset="md-1" className="image-list">
                            <Fade up>
                                <img src={reporting}/>
                            </Fade>
                        </Col>
                        <Col col="md-6 12" className="text-block">
                            <Slide right>
                                <h3>Reporting</h3>
                                <p>
                                   We ensure end to end management of the platform by monitoring performance and reliability and ensuring day to day activities are run correctly. Our reporting tools give our customers access to meaningful data on all the key aspects of their business.
                                </p>
                            </Slide>
                        </Col>
                        <i className="fa fa-circle"></i>
                    </Row>
                    <Row className="flip-order analytics">
                        <i className="fa fa-circle"></i>
                        <Col col="md-5 12" offset="md-1"  className="text-block">
                            <Slide right>
                                <h3>Data Analytics</h3>
                                <p>
                                    Our real-time data analytics software provides real-time data, charts and graphs to track operational performance. We collect data from all platform activities including:
                                        <br/>-Customer behaviour: page hits, registrations, conversion and retention rates<br/>-
                                        Traffic: web or USSD visits and sessions, SMS message receipts <br/>-
                                        Game statistics: ticket purchases, draw results, revenues, game wallet balance, player profiles <br/>-
                                        Mobile financial transactions with mobile operators <br/>-
                                        Payouts per game, per service and per operator
                                </p>
                            </Slide>
                        </Col>
                        <Col col="md-6 12">
                            <Fade up delay={1000}>
                                <img src={analytics}/>
                            </Fade>
                        </Col>
                        <i className="fa fa-circle"></i>
                    </Row>
                    <Row className="crm">
                        <Col col="md-3 12" offset="md-1">
                            <Fade up>
                                <img src={crm}/>
                            </Fade>
                        </Col>
                        <Col col="md-6 12"  className="text-block">
                            <Slide right>
                                <h3>Customer Care</h3>
                                <p>
                                    Our CRM systems allow our clients to manage relationships, data and information associated with all their customers, both current and potential. Our clients know the value of customer retention and loyalty so they therefore value the benefits our CRM systems can bring.
                                </p>
                            </Slide>
                        </Col>
                    </Row>
                    <Row className="flip-order analytics">
                        <i className="fa fa-circle"></i>
                        <Col col="md-5 12" offset="md-1"  className="text-block">
                            <Slide right>
                                <h3>Real-time Graphs</h3>
                                <p>
                                     FIlterable by any field available, e.g. operator and channel, and dynamically change chart type and period.
                                </p>
                            </Slide>
                        </Col>
                        <Col col="md-6 12">
                            <Fade up delay={1000}>
                                <img src={graph}/>
                            </Fade>
                        </Col>
                        <i className="fa fa-circle"></i>
                    </Row>
                    <Row className="crm">
                        <Col col="md-3 12" offset="md-1">
                            <Fade up>
                                <img src={bulk}/>
                            </Fade>
                        </Col>
                        <Col col="md-6 12"  className="text-block">
                            <Slide right>
                                <h3>BULK CAMPAIGN (SMS/USSD)</h3>
                                <p>
                                    Remotely access our intelligent mobile campaign web tools connected to your customer base and mobile operator networks for scheduling your next engagement or promotional message. Execute campaigns based on customers’ key performance indicators. Automatic post-campaign impact analysis, inclusive of how recipients responded to SMS promotional messages. (design attached)
                                </p>
                            </Slide>
                        </Col>
                    </Row>
                    <Row className="flip-order analytics">
                        <i className="fa fa-circle"></i>
                        <Col col="md-5 12" offset="md-1"  className="text-block">
                            <Slide right>
                                <h3>Profile Segmentation</h3>
                                <p>
                                     We compile data to profile customers in real-time with hundreds of key performance indicators per customer, game or service. Easy segmentation of players through interface filters plus automation of campaigns or games strategies by segments. (design attached)
                                </p>
                            </Slide>
                        </Col>
                        <Col col="md-6 12">
                            <Fade up delay={1000}>
                                <img src={segmentation}/>
                            </Fade>
                        </Col>
                        <i className="fa fa-circle"></i>
                    </Row>
                </Container>
            </section>
        <Footer />
        </div>
       );
    }
}
export default DataAnalytics;
